export default "__VITE_ASSET__c545d923__"